export const StorageService = Symbol.for('StorageService');
